import axios from "axios";

export const getAPI = async (url) => {
  const response = await axios
    .get(process.env.REACT_APP_SECRET + url)
    .then((res) => {
      // console.log("get method data: ", res);
      return res;
    })
    .catch((error) => {
      console.log("get method error :", error);
    });

  return response;
};

export const postAPI = async (url, body = []) => {
  const headers = {
    "Content-type": "application/json; charset=UTF-8",
  };
  const response = await axios
    .post(process.env.REACT_APP_SECRET + url, body, {
      headers: headers,
    })
    .then((data) => {
      // console.log("post method data: ", data);
      return data;
    })
    .catch((error) => {
      console.log("post method error :", error);
    });
  return response;
};
